import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_PsychEvalFollowUp = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_PsychEvalFollowUp' className='file-pdf-document'>

            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Person Seen:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="radio" id="rbPersonSeen_Consumer" name="rbPersonSeen" className='add-only' value="Consumer" /> Consumer
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbPersonSeen_Parent" name="rbPersonSeen" className='add-only' value="Parent/Guardian" /> Parent/Guardian
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbPersonSeen_FosterParent" name="rbPersonSeen" className='add-only' value="Foster Parent" /> Foster Parent
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbPersonSeen_SchoolCounselor" name="rbPersonSeen" className='add-only' value="School Counselor" /> School Counselor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbPersonSeen_Other" name="rbPersonSeen" className='add-only' value="Other" /> Other: &nbsp;
                            <input type='text' id="txtPersonSeen_Other" name="txtPersonSeen_Other" className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Location:</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="radio" id="rbLocation_Home" name="rbLocation" className='add-only' value="Home" /> Home
                        </td>
                        <td>
                            <input type="radio" id="rbLocation_LocalOffice" name="rbLocation" className='add-only' value="Local Office" /> Local Office
                        </td>
                        <td>
                            <input type="radio" id="rbLocation_PhysicianOffice" name="rbLocation" className='add-only' value="Physician Office" /> Physician Office(Face to Face)
                        </td>
                        <td>
                            <input type="radio" id="rbLocation_DivineOffice" name="rbLocation" className='add-only' value="Divine Office" /> Divine Office
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbLocation_Other" name="rbLocation" className='add-only' value="Other" /> Other: &nbsp;
                            <input type='text' id="txtLocation_Other" name="txtLocation_Other" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect/Mood:</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="radio" id="rbAffect_Happy" name="rbAffect" className='add-only' value="Happy" /> Happy
                        </td>
                        <td>
                            <input type="radio" id="rbAffect_Sad" name="rbAffect" className='add-only' value="Sad" /> Sad
                        </td>
                        <td>
                            <input type="radio" id="rbAffect_Angry" name="rbAffect" className='add-only' value="Angry" /> Angry
                        </td>
                        <td>
                            <input type="radio" id="rbAffect_Aloof" name="rbAffect" className='add-only' value="Aloof" /> Aloof
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbAffect_" name="rbAffect" className='add-only' value="Other" /> Other: &nbsp;
                            <input type='text' id="txtAffectOther" name="txtAffectOther" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Dress:</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="radio" id="rbDress_Appropriate" name="rbDress" className='add-only' value="Appropriate" /> Appropriate
                        </td>
                        <td>
                            <input type="radio" id="rbDress_Inappropriate" name="rbDress" className='add-only' value="Inappropriate" /> Inappropriate
                        </td>
                        <td>
                            <input type="radio" id="rbDress_Casual" name="rbDress" className='add-only' value="Casual" /> Casual
                        </td>
                        <td>
                            <input type="radio" id="rbDress_Disheveled" name="rbDress" className='add-only' value="Disheveled" /> Disheveled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbDress_Other" name="rbDress" className='add-only' value="Other" />
                            Other: <input type='text' id="txtDressOther" name="txtDressOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Progress:</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="radio" id="rbProgress_Improving" name="rbProgress" className='add-only' value="Improving" /> Improving
                        </td>
                        <td>
                            <input type="radio" id="rbProgress_NoProgress" name="rbProgress" className='add-only' value="NoProgress" /> No Progress
                        </td>
                        <td>
                            <input type="radio" id="rbProgress_Regression" name="rbProgress" className='add-only' value="Regression" /> Regression
                        </td>
                        <td>
                            <input type="radio" id="rbProgress_Completed" name="rbProgress" className='add-only' value="Completed" /> Completed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbProgress_Other" name="rbProgress" className='add-only' value="Other" />
                            Other: <input type='text' id="txtProgressOther" name="txtProgressOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please explain progress:</span>
                            <input type='text' id="txtProgressExplain" name="txtProgressExplain" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Relevant changes in medical conditions and/or medications, health and safety stressors(since last visit):</span>
                    <input type="radio" id="rbSaftyStressors_Yes" name="rbSaftyStressors" className='add-only' value="Yes" /> Yes<br />
                    <input type="radio" id="rbSaftyStressors_No" name="rbSaftyStressors" className='add-only' value="No" /> No, If YES, please list stressor(s):<br />
                    <textarea id="txtSaftyStressors" name="txtSaftyStressors" className='add-only'></textarea>
                </p>
                <h5>SOAP Note</h5>
                <p>
                    <span className='eleHeader'>(S):</span>
                    <textarea id="txtS" name="txtS" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>(O):</span>
                    <textarea id="txtO" name="txtO" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>(A):</span>
                    <textarea id="txtA" name="txtA" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>(P):</span>
                    <textarea id="txtP" name="txtP" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className="signature w-600">&nbsp;</td>
                        <td className="signature w-150">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-600">Physician Printed Name</td>
                        <td className="small w-150">Date of Note Entry</td>
                    </tr>
                    <tr>
                        <td className="signature w-600">&nbsp;</td>
                        <td className="signature w-150">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-600">Signature</td>
                        <td className="small w-150">Credentials</td>
                    </tr>
                </table>

            </div>
        </form>

    )
} 
